import { BaseContainerModel } from '../../base-container.model';
import { Bl_inv_stock_take_device_RowClass } from '../../../dbschema/bl_inv_stock_take_device.model';

export class StockTakeDeviceModel extends BaseContainerModel {
  bl_inv_stock_take_device: Bl_inv_stock_take_device_RowClass = new Bl_inv_stock_take_device_RowClass();
}
